import * as Dialog from '@radix-ui/react-dialog';
import { Spinner } from '@/shared/ui/atoms';

export type LoadingModalProps = {
  /** Título principal exibido abaixo do ícone */
  readonly title: string;
  /** URL/import de SVG para substituir a ilustração padrão */
  readonly illustration?: string | undefined;
};

export function LoadingModal({ illustration, title }: LoadingModalProps) {
  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-none z-40 bg-base-gray-900/deep text-" />
        <Dialog.Content
          aria-describedby={undefined}
          className="fixed left-1/2 top-1/2 z-50 flex w-[40rem] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-xxxs rounded-md bg-ctx-layout-surface py-lg text-center shadow-level1"
        >
          <Dialog.Title className="sr-only">{title}</Dialog.Title>
          <img className="size-huge" src={illustration} alt="" />
          <div className="flex flex-col gap-nano">
            <p className="text-ctx-content-title ts-heading-sm">{title}</p>
          </div>
          <Spinner />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
